import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, MatDialog } from '@angular/material';
import { PreferencesComponent } from '../preferences/preferences.component';
import { UtilityService } from '../../services/utility.service';
import { LoginService } from '../../services/login.service'
import { trigger, state, style, transition, animate } from '@angular/animations';
// import { ClientsComponent } from '../../clients/clients.component';
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
  ],
})

export class TableComponent implements OnInit {

  @Input('tableData') tableData
  @Input('displayColoumns') displayColumns
  @Input('preferenceList') userPreferences
  @Input('expand') expanded
  @Input('noDataMsg') noDataMsg
  @Output() searchText: EventEmitter<any> = new EventEmitter<any>();
  @Output() editUser: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteUser: EventEmitter<any> = new EventEmitter<any>();
  @Output() editData: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteData: EventEmitter<any> = new EventEmitter<any>();

  headers: any[];
  pageSizeOptions: number[] = [25, 50, 100];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  displayedColumns = []
  preferences = []
  noUsers = {
    title: "No Users!",
    data: "No users added yet!"
  }
  noClient = {
    title: "No Clients!",
    data: "Sorry, no clients matched your search"
  }
  actionList = []
  rowExpand = false


  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('expandedDetail');
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  constructor(
    public _utilityService: UtilityService,
    public _loginService: LoginService,
    public _route: Router
  ) {
    this.dataSource = new MatTableDataSource(this.tableData);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  ngOnChanges(changes: SimpleChanges): void {

    console.log("Changes in table component", changes);
    if (changes.displayColumns && changes.displayColumns.currentValue) {
      this.displayedColumns = changes.displayColumns.currentValue
      // this.headers = this.displayedColumns.map(col => col.key);
      // this.headersCopy = this.displayedColumns.map(col => col.title);
    }
    if (changes.tableData && changes.tableData.currentValue) {
      this.tableData = changes.tableData.currentValue
      // this.dataSource = new MatTableDataSource(this.tableData);
      this.updateData(this.tableData)
    }

    if (changes.userPreferences && changes.userPreferences.currentValue) {
      this.preferences = changes.userPreferences.currentValue
      this.actionList = this.preferences[this.preferences.length - 1]
    }

    if (changes.expanded && changes.expanded.currentValue) this.rowExpand = true
  }



  // UTILITY


  updateData(tableData) {
    console.log("Call this part or not", tableData);

    this.dataSource = new MatTableDataSource(tableData);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("single item", item);
      switch (property) {
        case 'name': return item.name;
        case 'email': return item.email;
        case 'address': return item && item.physicalAddress ? item.physicalAddress.address : null;
        case 'terms': return item.paymentTerms;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    // this.dataSource.sort = this.sort;
    console.log("Value of column header", this.displayedColumns, this.dataSource);

  }

  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }

  filter(searchText) {
    this.searchText.emit(searchText)
  }

  deleteUsers(user) {
    this.deleteUser.emit(user)
  }

  editUsers(user) {
    this.editUser.emit(user)
  }

  editAsset(asset) {
    this.editData.emit(asset)
  }
  deleteFixedAsset(assest) {
    this.deleteData.emit(assest)
  }

  // API CALL
  openActionPanel() {
    let obj = {
      preferences: this.preferences
    }
    console.log("Here the open new model", obj);
    this._utilityService.commonDialogBoxOpen(PreferencesComponent, obj)
      .afterClosed().subscribe((res) => {
        console.log("After action panel open", res, this._route.url);
        if (res == undefined) return res
        else
          this.displayedColumns = []
        // if (!res.includes('actions')) res.push('actions')
        // else {
        res.map((x) => {
          if (x.key !== 'actions' && x.value) this.displayedColumns.push(x.key)
          if (x.key === 'actions') this.displayedColumns.push(x.key)
        })
        let obj = {
          currentUrl: this._route.url,
          table: this.displayedColumns
        }
        this._loginService.setUserPreferences(obj).subscribe((updated) => {
          console.log("Preferences updated in data base", updated);
        }, err => {
          console.log("Error while update ", err);
        })
        // }

      })
  }

}
